import { AxiosRequestConfig } from 'axios';
import API from '../API';
import CustomerMifidAppropriateness from '../../models/CustomerMifidAppropriateness';

export const getAppropriatenessForCustomer = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
) => API.makeGetRequest(
  `/mifid/appropriateness`, queryParams, options,
) as Promise<CustomerMifidAppropriateness[]>;

export const saveAppropriateness = (
  body: Partial<CustomerMifidAppropriateness>,
  options: AxiosRequestConfig = {},
) => API.makePatchRequest(`/mifid/appropriateness`, body, {}, options);

export const deleteAppropriateness = (pathParams: { appropriatenessId: number }) =>
  API.makeDeleteRequest(`/mifid/appropriateness/${pathParams.appropriatenessId}`, {});
